export enum SERVICES_TAGS_TYPE {
  SPECIAL_OFFERS = 'SPECIAL_OFFERS',
  CASH_OFFERS = 'CASH_OFFERS',
  OTHER_OFFERS = 'OTHER_OFFERS',
}
